<div *ngIf="show" #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">Choose notification type</h4>
      </div>
      <div class="modal-body">
        <select class="form-control" [(ngModel)]="selectedType">
          <option *ngFor="let reason of reasons" [value]="reason.value">{{ reason.label }}</option>
        </select>
      </div>
      <div class="modal-footer"><button type="button" class="btn btn-success default-btn" (click)="submitModal()">Send</button></div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/new-id-notification-modal-dialog/new-id-notification-modal-dialog.component.html